// lazy.js
// Lazy-load images: Intersection Observer swaps data-src into src and
// toggles .lazyload to .lazyloaded to trigger the CSS fade-in transition.

function loadImage(image) {
  image.src = image.dataset.src;
  image.classList.remove('lazyload');
  image.classList.add('lazyloaded');
}

function initLazy() {
  const images = document.querySelectorAll('.lazyload');

  if (!images.length) return;

  if (!('IntersectionObserver' in window)) {
    images.forEach(loadImage);
    return;
  }

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadImage(entry.target);
        observerInstance.unobserve(entry.target);
      }
    });
  }, { threshold: 0.01 });

  images.forEach((image) => observer.observe(image));
}

export default initLazy;
